<template>
   <main>
     <Cover @closeNavBar="closeNav" v-if="display" />
     
       <transition enter-active-class="animate__animated animate__fadeIn">
          <Popup @closePopMessage="finalizeClosure" v-if="openPopupMessage"/>
       </transition>
    
    
      <section class="first">
         <Header class="animate__animated animate__slower animate__fadeIn" @open="returnOpenNav" />
         <div class="landing main display-flex">
            <div class="copy animate__animated animate__slow animate__fadeInUp">
               <h1>
                  Groceries and home <br> essentials exactly on  <br> your doorstep.
               </h1>
               <p>
                  <span> In as quick as 1 hour, we deliver all your<br>house needs with the aid of geolocation.</span>
                  <span>
                  <br>Be the first to know when we launch in <br> your city, sign up now.
                  </span>
               </p>
               <div class="btn">
                  <button>Learn More</button>
               </div>
            </div>
          
              <SignUp @openPopup="sendEventToOpenPopup" class="signup animate__animated animate__slow  animate__fadeInRight" />
         
         </div>
      </section>
      <section class="second">
        <div class="main display-flex order">
            <div class="mockup">
              <h1>Order your groceries <br> in 3 steps</h1>
               
               <div class="img">
                 <img src="../assets/mockup_1.svg" alt="">
               </div>
              
            </div>
            <div class="step_by_step">
                <Steps />
            </div>
        </div>
           <div class="main ta title">
           <h1>Additional Features</h1>
           <p>We have created a new product that will help riders and companies create better experiences grocery shopping.</p>
           <div class="cards">
              <div class="indiv" v-for="card in cardInfo" :key="card.id"  >
                <Card :header="card.header"  :text="card.text" :img="card.img" />
           </div>
           </div>
        </div>
      </section>


      <section class="third">
        <div class="app main display-flex">
          <div class="text">
             <h1>Our App is on the way!</h1>
             <p>Those buttons don’t work now though, when you join the waitlist, we tell you when our app is live! Join the waitlist now to get early access.</p>
             
             <div class="get">
               <p>Get the App</p>
               <div class="buttons display-flex">
                  <div class="div">
                    <img src="../assets/App_Store_Badge.png" alt="">
                  </div>
                  <div class="div">
                    <img src="../assets/google_badge.png" alt="">
                  </div>
               </div>
             </div>
          </div>

          <div class="img">
            <img src="../assets/delivery.svg" alt="">
          </div>
        </div>
      </section>
      <footer>
        <Footer/>
      </footer>
   </main>
</template>

<script>
import Popup from '../components/popUp.vue'
import Header from '../components/header.vue';
import "animate.css"
import Card from "../components/card.vue";
import Steps from '../components/table.vue'
import Cover from '../components/navbar_drop.vue'
import SignUp from '../components/signup.vue'
import Footer from '../components/footer.vue'
export default {
  name: 'Home',
  components: {Header, SignUp, Steps, Card, Footer, Cover, Popup},
  data(){
    return{
      openPopupMessage: false,
      display: false,
         cardInfo: [
           { 
             id:1,
             header: "For Riders",
             text:"Incentive based rides that allow you to get more money based on journey time — cha ching",
             img: '09.svg'
           },
           {
             id:2,
             header:'For Merchants',
             text:'Management terminal that offers as a point of sale system in-store and an online deliveries system',
             img: '01.svg'
           }
         ]
    }
  },
  methods: {
    returnOpenNav: function(){
      this.display = !this.display;
    },
    closeNav(){
      this.display = false;
    },
    sendEventToOpenPopup(){
       this.openPopupMessage = true;
    },
    finalizeClosure(){
      this.openPopupMessage = false;
    }
  }
}
</script>


<style lang="scss" scoped>
.cover{
  display: none;
}
main{
  .first{
    background:#AB0519;
      padding:10px 0px;
  }
  .landing{
    font-family: 'DM sans';
    padding-top:60px;
    padding-bottom: 70px;
    color: white;
    .copy{
      width:50%;
      h1{
        margin-bottom: 10px;  
      }
      p{
          margin:20px 0px;
          font-size: 1em;
          line-height: 23px;
          span{
            &:nth-child(2){
            display: block;
            }
          }
      }
      .btn{
        margin-top: 30px;
        button{
           outline: none;
           color: white;
           font-family: 'DM sans';
           height: 50px;
          width: 157px;
           border: none;
           font-size: 1.1em;
           background-color: #67000D;
           border-radius: 10px;
        }
      }
    }
  }
  .second{
    background-image:url('../assets/BG.svg');
    background-position: top;
    background-repeat: no-repeat;
    background-size:100%;
     .order{
         padding:70px 0px;
         .step_by_step{
            width:54%;
            margin-top:50px;
         }
         .mockup{
           width:40%;
           h1{
              font-family: 'DM sans', sans-serif;
              color:#18191F;
           }
           .img{
             width:100%;
             margin:10% 0;
             img{
               width: 100%;
             }
           }
         }
     }
     .title{
       margin:50px auto;
       padding: 20px 0px;
        font-family: 'DM sans', sans-serif;
       h1{
         color: #000000;
       }
       P{
         margin:20px auto;
         width: 60%;
       }
       .cards{
         display: flex;
         width: 80%;
         margin: 50px auto;
         align-items: center;
         justify-content: space-between;
         .indiv{
           width: 46%;
         }
       }
     }
  }
  .third{
    font-family:'Inter', sans-serif;
    background-color: #05AB97;
    background-image:url('../assets/Pattern.svg');
    background-repeat: no-repeat;
    background-size: 30%;
    background-position: 95%;
    padding-top:60px;
;
    .app{
      align-items: flex-start;
      .text{
        width:50%;
        h1{
           font-family: 'Inter';
          font-weight: 800;
        color: white;
        line-height: 64px;
        }
        p{
          margin: 20px 0px;
          max-width: 80%;
          color: #FDFEFE;
          font-size: 1em;
          line-height: 25px;

        }
        .get{
          margin-top:40px;
          .buttons{
             width: 50%;
          }
        }
      }
      .img{
        width:20%;
        img{
          width: 100%;
        }
      }
    }
  }
  footer{
    background: #121417;
  }
}

@media(max-width:836px){
  main{
       .first{
      .landing{
        flex-direction: column;
        height:600px;
        .copy{
          width:100%;
        }
        .signup{
          margin-top: 10%;
        }
      }
    }
    .second{
      margin-top:50vh !important;
      background-size: 200%;
      .title{
        .cards{
          flex-direction: column;
           margin: 20px auto;
          .indiv{
            width: 80%;
            margin:20px 0px;
          }
        }
      }
    }
  }
}
@media (max-width:957px){
  main{
.second{
  .order{
    flex-direction: column;
    .step_by_step{
      width:100%;
    }
    .mockup{
      width:100%;
      .img{
        width:80%;
      }
    }
  }
}
.third{
  background-position-x: center;
  background-position-y:80%;
  background-size: 40%;
  .app{
    flex-direction: column;
    .text{
      width:100%;
      .get{
        margin-top:30px;
        .buttons{
          width:35%;
          flex-direction: row;
        }
      }
    }
    .img{
      margin-top:50px !important;
      margin:0 auto;
      width:30%;
    }
  }
}
  }
}
@media  (max-width:600px){
  main{
    .second{
      .order{
        padding:60px 0px;
        .mockup{
          width: 100%;
          .img{
            width:100%;
          }
        }
      }
      .title{
        p{
          width: 98%;
        }
       .cards{
         width: 100%;
         .indiv{
           width: 100%;
         }
       }
      }
    }
    .third{
      background-size: 75%;
      background-position-y: 90%;
    .app{
        .text{
          .get{
               .buttons{
                   width: 60%;
                  flex-direction: row;
                 }
          }
       }
       .img{
         width:60%;
       }
    }
  }
  }
}
@media (max-width:390px){
  .third{
    .app{
       h1{
         line-height: normal;
         font-size: 1.7em;
       }
    }
  }
}
</style>
